import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TopicService {
  constructor(private http: HttpClient) { }

  getById(id: string) {
    return this.http.get<any>(environment.app.apiUrl + `topic/get/${id}`).toPromise();
  }
  getDetail(id: string) {
    return this.http.get<{ topic: any, jobs: any[], related: any[] }>(environment.app.apiUrl + `topic/detail/${id}`).toPromise();
  }

  search(criteria: any, from = 0, limit = 30) {
    return this.http.get<any>(environment.app.apiUrl + `topic/search/${from}/${limit}`, { params: { criteria: JSON.stringify(criteria) } }).toPromise();
  }

  save(topic: any) {
    return this.http.post<any>(environment.app.apiUrl + 'topic/save', topic).toPromise();
  }

  add(title: string, body: string, ...tags: string[]) {
    return this.http.post<any>(environment.app.apiUrl + 'topic/add', { title, body, tags }).toPromise();
  }

  message(topicId: string, message: any) {
    return this.http.post<any>(environment.app.apiUrl + `topic/message/${topicId}`, message).toPromise();
  }

  toggleFollow(topicId: string) {
    return this.http.post<any>(environment.app.apiUrl + `topic/toggle-follow/${topicId}`, null).toPromise();
  }

  suggest(keyword: string): any {
    return this.http.get<any>(environment.app.apiUrl + `topic/suggest/${keyword}/10`).toPromise();
  }

  hot(limit = 30) {
    return this.http.get<any[]>(environment.app.apiUrl + `topic/hot/${limit}`).toPromise();
  }
}
